function Password(params) {
    return(
        <div>
            hola
        </div>
    )
}

export default Password